





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import { UserSearchRequest } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import { User, AuthModule } from '@/store/modules/auth';
import { ProcessModule } from '@/store/modules/process';

@Component({
  components: {
    SelectionField,
    InfoTooltip,
    DeleteIcon
  }
})
export default class AssociatedPersonsInput extends Vue {
  @Prop(Boolean)
  disabled!: boolean;
  @Prop(Boolean)
  hasError!: boolean;

  get state() {
    return ProcessModule;
  }

  get users() {
    return CommonModule.users;
  }

  search(name: string) {
    const request: UserSearchRequest = { name: `${name}`, cvr: '' };
    if (AuthModule.user) {
      request.cvr = AuthModule.user.cvr;
      CommonModule.searchUsers(request);
    } else {
      CommonModule.searchUsers(request);
    }
  }

  addUser(user: User) {
    if (!user || ProcessModule.users?.find((u: User) => user.id === u.id)) {
      return;
    }

    setTimeout(() => (this.$refs.userSelectionField as SelectionField<User>).clear());
    ProcessModule.addUser(user);
  }

  removeUser(user: User) {
    ProcessModule.removeUser(user);
  }
}
